import { InputDropdown } from '@platform/components';
import { SimplifiedUserRole, MatchDiscoveryUpdateOutcomeEnum } from '@platform/client/schemas';
import { UpdateDiscoveryCallFormData } from './types';
import { FormState, UseFormSetValue } from 'react-hook-form';

type UpdateSelectionContentProps = {
  setValue: UseFormSetValue<UpdateDiscoveryCallFormData>;
  selectedStatus: MatchDiscoveryUpdateOutcomeEnum | undefined | null;
  userType: SimplifiedUserRole;
  formState: FormState<UpdateDiscoveryCallFormData>;
};

// The other party the user is being matched with: an organization (for pros) or a professional (for reps)
const getStatusItems = (userType: SimplifiedUserRole) => {
  const isPro = userType === SimplifiedUserRole.PROFESSIONAL;
  return [
    { text: "Yes, it's a match!", textValue: MatchDiscoveryUpdateOutcomeEnum.matched },
    { text: "No, it's not a good fit", textValue: MatchDiscoveryUpdateOutcomeEnum.not_a_good_fit },
    { text: "We're scheduled to meet", textValue: MatchDiscoveryUpdateOutcomeEnum.scheduled },
    {
      text: "I'm still deciding / comparing options",
      textValue: MatchDiscoveryUpdateOutcomeEnum.still_deciding,
    },
    {
      text: isPro ? 'The organization is unresponsive' : 'The professional is unresponsive',
      textValue: MatchDiscoveryUpdateOutcomeEnum.unresponsive,
    },
    {
      text:
        isPro ?
          "I've matched with a different organization"
        : "I've matched with a different professional",
      textValue: MatchDiscoveryUpdateOutcomeEnum.matched_elsewhere,
    },
    { text: 'I have a different update', textValue: MatchDiscoveryUpdateOutcomeEnum.other },
  ];
};

export const UpdateSelectionContent = (props: UpdateSelectionContentProps) => {
  return (
    <div className='flex flex-col gap-8 items-center md:mt-8 md:w-[500px]'>
      <div className='text-center text-xl'>What's the status of your Discovery Call?</div>
      <div className='mt-4 w-full'>
        <InputDropdown
          type='default'
          aria-label='Update'
          placeholder='Select an update'
          inputDisabled
          items={getStatusItems(props.userType)}
          selectedKey={props.selectedStatus ?? undefined}
          onSelectionChange={(key) => {
            props.setValue('status', key as MatchDiscoveryUpdateOutcomeEnum, {
              shouldValidate: true,
            });
          }}
          errorText={props.formState.errors.status?.message}
        />
      </div>
    </div>
  );
};
